import Marquee from "react-fast-marquee";

const WORDS = [
  "24/7",
  "REBOQUE",
  "BELÉM",
  "ANANINDEUA",
  "MARITUBA",
  "BR-316",
  "SOCORRO",
  "BR-010",
  "PLANTÃO",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      aria-label="Áreas atendidas em destaque"
      className="relative border-y border-chrome/20 bg-black py-8 sm:py-10"
    >
      <Marquee gradient={false} speed={55} pauseOnHover={false}>
        {[...WORDS, ...WORDS].map((w, i) => (
          <span
            key={i}
            className="mx-6 inline-flex items-center gap-6 font-display text-[9vw] uppercase tracking-tighter leading-none sm:mx-10 sm:text-[7vw]"
          >
            <span
              className={
                i % 2 === 0
                  ? "text-brand-yellow"
                  : "text-transparent [-webkit-text-stroke:1.5px_#C0C0C0]"
              }
            >
              {w}
            </span>
            <span className="text-brand-yellow/70">✱</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
